import React from "react";
import { Navigate, Outlet, useLocation } from "react-router";
import { useAppSettingsService } from "src/services/appSettingsService/appSettingsService";
import { getSettings } from "src/services/configService";
import { useEnrollmentFlowEnabled } from "src/ui/containers/dashboard/enrollment/utils/useEnrollmentFlowEnabled";
import {
    getFirstAvailableDashboardPath,
    isDashboardPageAccessible,
} from "src/ui/navigation/dashboardRouting/dashboardRouting";

export const PageGuard = () => {
    const location = useLocation();
    const pathname = location.pathname;
    const { features } = getSettings();
    const { effectiveWorkspaceSettings, isLoading } = useAppSettingsService();
    const isEnrollmentPageEnabled = useEnrollmentFlowEnabled();
    const accessContext = { effective: effectiveWorkspaceSettings, pages: features.pages };

    if (pathname === "/register" && !features.registrationEnabled) {
        return <Navigate to="/login" replace />;
    }

    if (pathname === "/dashboard/enrollment" && isEnrollmentPageEnabled) {
        return <Outlet />;
    }

    if (pathname === "/embedded/third-party" && !features.pages.ossLicensesPageEnabled) {
        return <Navigate to="/forbidden" replace />;
    }

    const isAccessible = isDashboardPageAccessible(pathname, accessContext);
    if (isAccessible === null) {
        return <Outlet />;
    }

    // Workspace-dependent pages: avoid a false "not accessible" redirect while the workspace
    // (and therefore effectivePageVisibility) is still loading.
    if (isLoading || isAccessible) {
        return <Outlet />;
    }

    const next = getFirstAvailableDashboardPath(accessContext);
    if (next === null || next === pathname) {
        return <Navigate to="/forbidden" replace />;
    }
    return <Navigate to={next} replace />;
};
